import type { RouteRecordRaw } from 'vue-router';

export const activityLogRoutes: RouteRecordRaw[] = [
  {
    path: 'activity-log',
    name: 'activity-log',
    component: () => import('./pages/ActivityLogPage.vue'),
    meta: { title: 'Activity log', requiresAuth: true },
  },
  {
    path: 'activity-log/:id',
    name: 'activity-log.show',
    component: () => import('./pages/ActivityDetailPage.vue'),
    meta: { title: 'Activity', requiresAuth: true },
  },
];
